export class Provincia {
    constructor(
      public readonly Id: number,
      public readonly Codigo: string | null,
      public readonly Nombre: string | null,
      public readonly PaisId: number,
      public  Activo: boolean,
    ) {}
  }

  export class SearchProvinciaRequest {
    constructor(
      public readonly PageSize: number | null,
      public readonly PageNumber: number | null,
      public readonly OrderAscending: boolean | null,
      public readonly OrderFieldName: string | null,
      public readonly Nombre: string | null,
      public readonly Codigo: string | null,
      public readonly PaisId: number | null,
      public readonly VerSoloActivos: boolean | null
    ) {}
  }

  export class SaveProvinciaDto {
    constructor(
      public Id: number,
      public Nombre: string | null,
      public Codigo: string | null,
      public PaisId: number | null,
      public Activo: boolean
    ) {}
  }

  export class SearchProvinciaResponse {
    constructor(
      public readonly count: number,
      public readonly result: Provincia[]
    ) {}
  }
